import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/Car/SelectDriverField/SelectDriverField.module.css'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { DriverSelectField } from '../../Drivers/DriverSelectField/DriverSelectField'

export function SelectDriverField ({ fieldName, disabled }) {
  const [driver, setDriver] = useState([])

  const onSelect = (id, driver) => {
    setDriver(driver)
  }
  const { t } = useTranslation()

  return <>
    <DriverSelectField
      label={t('form.car.driver')}
      fieldName={fieldName}
      className={styles.select}
      disabled={disabled}
      onChange={onSelect}
    />
    <ReadOnlyTextField
      variantValue={'filled'}
      value={driver ? driver.firstName : ''}
      label={t('form.car.driverCredentials.firstName')}
      disabled
    />
    <ReadOnlyTextField
      variantValue={'filled'}
      value={driver ? driver.lastName : ''}
      label={t('form.car.driverCredentials.lastName')}
      disabled
    />
    <ReadOnlyTextField
      variantValue={'filled'}
      value={driver ? driver.phoneNumber : ''}
      label={t('form.car.driverCredentials.phoneNumber')}
      disabled
    />
  </>
}
